import { useCallback, useMemo } from 'react';
import { useTracking } from '@podiumhq/tracking';

import { useBusinessInfoContext } from 'contexts/BusinessContextProvider';
import { useNotificationContext } from 'contexts/NotificationContextProvider';
import { useTrialsContext } from 'contexts/TrialsContextProvider';
import { setTrialError } from '../utils';

const useTrialCreationVariables = () => {
  const { businessInfo = {} } = useBusinessInfoContext() || {};
  const {
    setShouldDisplay: shouldDisplayError,
    setCustomMessage,
    setErrorReason,
  } = useNotificationContext() || {};
  const { trackEvent } = useTracking();
  const { email, firstName, lastName, phone } = useTrialsContext() || {};

  const setTrialCreationError = useCallback(
    (error, isStripeError = false) =>
      setTrialError({
        error,
        isStripeError,
        setCustomMessage,
        setErrorReason,
        shouldDisplayError,
        trackEvent,
      }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  const baseVariables = useMemo(
    () => ({
      businessName: businessInfo.name,
      email,
      firstName,
      lastName,
      phone: phone || businessInfo.phone,
      postalCode: businessInfo.zip,
    }),
    [
      businessInfo.name,
      businessInfo.phone,
      businessInfo.zip,
      email,
      firstName,
      lastName,
      phone,
    ]
  );

  return useMemo(
    () => ({ baseVariables, setTrialCreationError, trackEvent }),
    [baseVariables, setTrialCreationError, trackEvent]
  );
};

export default useTrialCreationVariables;
